import * as PickingHttp from '../../../../services/api/https/picking/picking.http'
import * as TeamHttp from '../../../../services/api/https/picking/picking-team.http'
import { errorHandler } from '../../../../services/util/error.service'
import { useMemo, useState } from 'react'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_TEAM: 'Adquirindo equipes',
  GET_ASSOC: 'Adquirindo informações iniciais',
  SAVE_ASSOC: 'Salvando associações',
  UPDATE_ANY_CHECKERS: 'Atualizando conferentes',
  SUCCESS: 'Operação realizada com sucesso',
}

const INITIAL_STATE = {
  equipes: [],
  associationsAreaTeam: [],
  selecionarTodos: false,
  selecionarTodos2Conferentes: true,
  selectedEquipe: '',
  apelido: '',
  errorMessage: null,
  loadingMessage: LOAD_MESSAGE.GET_TEAM,
}

export default function useAssocEquipeSeparacao() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      associateDeliveryToTeam(associationsAreaTeam, picking_id, equipe_id) {
        if (!equipe_id) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione uma equipe para efetuar a associação.',
          }))
        } else {
          const selectedAreasIds = associationsAreaTeam.filter(e => e.selected).map(i => i.area_id)
          if (!selectedAreasIds.length) {
            setState(prevState => ({
              ...prevState,
              errorMessage: 'Selecione pelo menos uma area para associar.',
            }))
          } else {
            PickingHttp.associateDeliveryToTeam(selectedAreasIds, picking_id, equipe_id)
              .then(associationsAreaTeam =>
                setState(prevState => ({
                  ...prevState,
                  associationsAreaTeam: associationsAreaTeam,
                  selecionarTodos: false,
                  loadingMessage: LOAD_MESSAGE.NONE,
                })),
              )
              .catch(err =>
                setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })),
              )
          }
        }
      },
      getEquipes(tp_id) {
        TeamHttp.getEquipes(tp_id)
          .then(equipes => {
            setState(prevState => ({
              ...prevState,
              equipes: equipes.filter(e => e.actived),
              selecionarTodos: false,
              loadingMessage: LOAD_MESSAGE.GET_ASSOC,
            }))
          })
          .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
      },
      getAreaAndTeamAssociation(id) {
        PickingHttp.getAreaAndTeamAssociation(id)
          .then(associationsAreaTeam =>
            setState(prevState => ({
              ...prevState,
              associationsAreaTeam: associationsAreaTeam,
              selecionarTodos: false,
              selecionarTodos2Conferentes: associationsAreaTeam.some(
                e => e.area_id && !e.any_checkers,
              )
                ? false
                : true,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
      },
      resetState() {
        setState({ ...INITIAL_STATE })
      },
      onCheckBoxRowClicked(assoc) {
        assoc.selected = !assoc.selected
        setState(prevState => {
          const index = prevState.associationsAreaTeam.find(e => e.area_id === assoc.area_id)
          if (index !== -1) prevState.associationsAreaTeam[index] = assoc
          return { ...prevState }
        })
      },
      onSelecionarTodosChange(value) {
        setState(prevState => ({
          ...prevState,
          associationsAreaTeam: prevState.associationsAreaTeam.map(e => ({
            ...e,
            selected: value,
          })),
          selecionarTodos: value,
        }))
      },
      onSelecionarTodos2ConferentesChange(value, picking_id) {
        setState(prevState => ({
          ...prevState,
          associationsAreaTeam: prevState.associationsAreaTeam.map(e => ({
            ...e,
            any_checkers: e.area_id ? value : e.any_checkers,
          })),
          selecionarTodos2Conferentes: value,
          loadingMessage: LOAD_MESSAGE.UPDATE_ANY_CHECKERS,
        }))

        PickingHttp.updateAnyCheckersPicking(picking_id, value)
          .then(() => {
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err => {
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
      },
      onBtnSalvarClicked(equipes) {
        if (equipes.length !== 0) {
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE_ASSOC }))
        } else {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Não Existem Equipes de Separação Cadastradas',
          }))
        }
      },
      onFormControlChange(value) {
        setState(prevState => ({ ...prevState, selectedEquipe: value }))
      },
      onAnyCheckersChange(assoc, picking_id, value) {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.UPDATE_ANY_CHECKERS }))

        PickingHttp.updateAnyCheckersArea(picking_id, assoc.area_id, value)
          .then(() => {
            setState(prevState => {
              const updatedAssociations = prevState.associationsAreaTeam.map(e =>
                e.area_id === assoc.area_id ? { ...e, any_checkers: value } : e,
              )
              return {
                ...prevState,
                associationsAreaTeam: updatedAssociations,
                loadingMessage: LOAD_MESSAGE.NONE,
              }
            })
          })
          .catch(err => {
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
      },
    }
  }, [])

  return { state, localDispatch }
}
